<template>
  <div>
  <footer
    :class="[{ footer: true, footerStyle1: reliability.gridOn, footerStyle2: !reliability.gridOn }, { 'noselect': true }]">
    <div class="vPosition">
      <div>
        <img v-if="user && src" :src="src" width="80" height="40" :alt="$t('logo-da-unidade')" id="footer-logo" />
        <span v-else-if="!user" style="color: #fff;"><strong>GDI/PGDI</strong></span>
      </div>
      <div v-if="user && unitName" class="unitInfo">{{ unitName.toUpperCase() }}</div>
    </div>
    <div class="reportBox" v-if="infoReport.show">
      <div class="globalBoxInfo vPosition">
        <span>{{ dt1 }}</span>
        <span></span>
        <span>{{ dt2 }}</span>
      </div>
    </div>
    <div class="testBox" v-if="reliability.gridOn">
      <div class="testBoxHeader">{{ rotacaoTituloAtivo }}</div>
      <div class="testBoxRow">
        <div v-for="(campo, idx) in camposAtivos" :key="idx" class="testBoxCampo">
          <span class="testBoxValue">{{ campo.value }}</span>
          <span class="testBoxLabel">{{ campo.nome }}</span>
        </div>
      </div>
      <button
        v-if="user && user.Permissions && user.Permissions.editartelamonitoramento && user.Permissions.editartelamonitoramento.allowed && monitoringEditorMode"
        class="testBoxAddBtn" title="Variáveis fixas" @click="openModal" :disabled="loadingModal">
        <b-spinner v-if="loadingModal" small class="testBoxAddBtnSpinner"></b-spinner>
        <b-icon v-else icon="gear" aria-hidden="true"></b-icon>
      </button>
    </div>
    <span v-if="msg != null" :class="[{ msgTxt: true }, { vPosition: true }, { unitNameDivisor: reliability.pgdi }, { msgTxtOnlineRunning: parsedMsg.isOnlineRunning }]">
      <template v-if="parsedMsg.isOnlineRunning">
        <label class="msgTxtOnlineMain">{{ parsedMsg.mainText }}</label>
        <span class="msgTxtOnlineSub">{{ parsedMsg.subText }}</span>
      </template>
      <template v-else>{{ msg }}</template>
    </span>
    <div class="globalBox globalBoxPgdi" v-if="reliability.pgdi">
      <div class="globalBoxHeader">{{ $t('aderencia-global') }}</div>
      <div class="globalBoxInfo">
        <span>{{ reliability.a.replace(',', '.') | numberFormat }}</span>
        <span>{{ reliability.b.replace(',', '.') | numberFormat }}</span>
        <span>{{ reliability.c.replace(',', '.') | numberFormat }}</span>
      </div>
      <div class="globalBoxLabels">
        <span>{{ reliability.a_name }}</span>
        <span>{{ reliability.b_name }}</span>
        <span>{{ reliability.c_name }}</span>
      </div>
    </div>
    <div class="globalBox" v-else-if="reliability.daily && !reliability.pgdi">
      <div class="globalBoxHeader">{{ $t('aderencia-global-0') }}</div>
      <div class="globalBoxInfo">
        <span>{{ reliability.daily.replace(',', '.') | numberFormat }}</span>
      </div>
    </div>
    <span class="pentagroTxt vPosition">{{ $t('pentagro-c-desde-2013') }}</span>
  </footer>

  <b-modal id="modalIndicadoresFixos" title="Indicadores Fixos" hide-footer no-enforce-focus size="xl" modal-class="modal-indicadores-fixos">
    <div class="modal-field">
      <label class="modal-label">Intervalo de Tempo em Segundos</label>
      <b-form-input v-model.number="intervaloTempo" type="number" min="1" style="max-width: 160px;" />
    </div>
    <hr class="modal-divider" />
    <div v-for="s in 3" :key="s">
      <b-form-input
        :value="rotacaoTitles[s-1]"
        @input="$set(rotacaoTitles, s-1, $event)"
        size="sm"
        class="modal-rotacao-input"
        :placeholder="`Rotação ${s}`"
        maxlength="20"
      />
      <div class="modal-7col mt-2">
        <span v-for="n in 7" :key="'h'+n" class="modal-col-header">Campo {{ n }}</span>
      </div>
      <div class="modal-7col mt-1">
        <b-form-input
          v-for="n in 7" :key="'nome'+n"
          v-model="campos[n-1].slots[s-1].nome"
          size="sm"
          :placeholder="`Nome ${n}`"
          maxlength="12"
        />
      </div>
      <div class="modal-7col mt-1">
        <SearchableSelect
          v-for="n in 7" :key="'ind'+n"
          :modelRef="campos[n-1].slots[s-1].indicador"
          :optList="allIndicators"
          optValue="indicatorName"
          optDisplay="indicatorName"
          :inputFunc="makeIndicadorSetter(n-1, s-1)"
          placeholder="-- Selecione --"
          extraClass="select-highlight"
          :clearable="true"
        />
      </div>
      <hr v-if="s < 3" class="modal-campo-sep" />
    </div>
    <div v-if="erroSalvar" class="erro-salvar-msg">{{ erroSalvar }}</div>
    <div class="modal-footer-actions">
      <b-button variant="secondary" @click="$bvModal.hide('modalIndicadoresFixos')">Cancelar</b-button>
      <b-button class="btn-orange-save" @click="salvarIndicadoresFixos">Salvar</b-button>
    </div>
  </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
import { urlMainAPI, ParseNumberToUser } from '../../global';
import SearchableSelect from '../rta/commons/SearchableSelect.vue';

var footerPentagro = null;

export default {
  name: "Footer",
  components: { SearchableSelect },
  computed: {
    ...mapState(["user", "msg", "dt1", "dt2", "infoReport", "reliability", "unitName", "monitoringEditorMode", "indicatorsData"]),
    parsedMsg() {
      const raw = typeof this.msg === 'string' ? this.msg : '';
      const onlineLabel = this.$t('onlineActive');
      const modelLabel = this.$t('model');
      if (raw.startsWith(onlineLabel)) {
        const idx = raw.indexOf(modelLabel);
        return {
          isOnlineRunning: true,
          mainText: onlineLabel,
          subText: idx >= 0 ? raw.slice(idx).trim() : '',
        };
      }
      return { isOnlineRunning: false, mainText: '', subText: '' };
    },
    rotacaoTituloAtivo() {
      return this.rotacaoTitles[this.rotacaoIndex] || `Rotação ${this.rotacaoIndex + 1}`;
    },
    camposAtivos() {
      return this.campos.reduce((acc, campo) => {
        const slot = campo.slots[this.rotacaoIndex];
        if (!slot || !slot.indicador) return acc;
        const item = this.indicatorsData[slot.indicador] || this.localIndicatorsData[slot.indicador];
        const raw = item ? item.onlineValue : '-';
        let value = raw !== '-' && raw != null ? ParseNumberToUser(raw) : raw;
        acc.push({ nome: slot.nome || slot.indicador, value });
        return acc;
      }, []);
    },
  },
  data: function () {
    return {
      year: null,
      secondType: false,
      src: null,
      intervaloTempo: 10,
      allIndicators: [],
      campos: Array.from({ length: 7 }, () => ({
        slots: [
          { nome: ``, indicador: null },
          { nome: '', indicador: null },
          { nome: '', indicador: null },
        ]
      })),
      rotacaoTitles: ['Rotação 1', 'Rotação 2', 'Rotação 3'],
      rotacaoIndex: 0,
      rotacaoTimer: null,
      localIndicatorsData: {},
      fetchTimer: null,
      erroSalvar: null,
      loadingModal: false,
    }
  },
  filters: {
    numberFormat(num) {
      return parseFloat(num).toFixed(2) + " %"
    }
  },
  methods: {
    setCurrentYear() {
      let currentYear = new Date;
      this.year = currentYear.getFullYear();
    },

    async loadImage() {
      let url = urlMainAPI;
      await axios.get(`${url}/getfooter`, { responseType: 'blob' })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.src = reader.result;
          }
        })
        .catch(ex => {
          console.error(ex);
        });
    },

    checkUser() {
      if (this.user) {
        this.loadImage()
        this.iniciarBuscaIndicadores()
        this.carregarConfigDoBackend()
        clearInterval(footerPentagro)
      }
    },

    carregarConfigDoBackend() {
      axios.get(`${urlMainAPI}/configurator/getfixedindicatorsconfig`)
        .then(res => {
          if (!res.data) return;
          const raw = typeof res.data === 'string' ? res.data : JSON.stringify(res.data);
          localStorage.setItem('fixedIndicatorsConfig', raw);
          const parsed = JSON.parse(raw);
          if (parsed.intervaloTempo) this.intervaloTempo = parsed.intervaloTempo;
          if (parsed.campos) this.campos = parsed.campos;
          if (parsed.rotacaoTitles) this.rotacaoTitles = [...parsed.rotacaoTitles];
          this.iniciarRotacao();
        })
        .catch(() => { /* backend indisponível ou coluna não existe ainda — usa localStorage */ });
    },

    async salvarIndicadoresFixos() {
      const temIndicadorNaPrimeiraRotacao = this.campos.some(c => c.slots[0] && c.slots[0].indicador);
      if (!temIndicadorNaPrimeiraRotacao) {
        this.erroSalvar = 'A primeira rotação deve ter pelo menos um indicador configurado.';
        return;
      }
      this.erroSalvar = null;
      this.rotacaoTitles = [...this.rotacaoTitles];
      const payload = JSON.stringify({ intervaloTempo: this.intervaloTempo, campos: this.campos, rotacaoTitles: this.rotacaoTitles });
      localStorage.setItem('fixedIndicatorsConfig', payload);
      await axios.post(`${urlMainAPI}/configurator/savefixedindicatorsconfig`, JSON.stringify(payload), { headers: { 'Content-Type': 'application/json' } })
        .catch(console.error);
      this.iniciarBuscaIndicadores();
      this.iniciarRotacao();
      this.$bvModal.hide('modalIndicadoresFixos');
    },

    iniciarBuscaIndicadores() {
      if (this.fetchTimer) clearInterval(this.fetchTimer);
      const fetch = () => {
        axios.get(`${urlMainAPI}/getindicatorcurrentvalues`)
          .then(res => {
            const raw = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            const map = {};
            Object.entries(raw).forEach(([name, value]) => { map[name] = { onlineValue: value }; });
            this.localIndicatorsData = map;
          })
          .catch(console.error);
      };
      fetch();
      this.fetchTimer = setInterval(fetch, 60 * 1000);
    },

    proximaRotacaoValida(fromIndex) {
      for (let i = 1; i <= 3; i++) {
        const next = (fromIndex + i) % 3;
        if (this.campos.some(c => c.slots[next] && c.slots[next].indicador)) return next;
      }
      return fromIndex;
    },

    iniciarRotacao() {
      if (this.rotacaoTimer) clearInterval(this.rotacaoTimer);
      const primeiro = [0, 1, 2].find(i => this.campos.some(c => c.slots[i] && c.slots[i].indicador)) ?? 0;
      this.rotacaoIndex = primeiro;
      const intervalo = (this.intervaloTempo || 10) * 1000;
      this.rotacaoTimer = setInterval(() => {
        this.rotacaoIndex = this.proximaRotacaoValida(this.rotacaoIndex);
      }, intervalo);
    },

    makeIndicadorSetter(campoIdx, slotIdx) {
      return (e) => {
        this.$set(this.campos[campoIdx].slots[slotIdx], 'indicador', e.target.value);
      };
    },

    async openModal() {
      if (this.loadingModal) return;
      this.loadingModal = true;
      if (this.allIndicators.length === 0) {
        await axios.get(`${urlMainAPI}/getproductioninfos`)
          .then(res => {
            const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            this.allIndicators = (data.allIndicators || []).sort((a, b) =>
              (a.indicatorName || '').localeCompare(b.indicatorName || '')
            );
          })
          .catch(console.error);
      }
      this.loadingModal = false;
      this.$bvModal.show('modalIndicadoresFixos');
    }
  },
  created() {
    footerPentagro = setInterval(() => { this.checkUser() }, 500)
    this.setCurrentYear();
    const saved = localStorage.getItem('fixedIndicatorsConfig');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.intervaloTempo) this.intervaloTempo = parsed.intervaloTempo;
        if (parsed.campos) this.campos = parsed.campos;
        if (parsed.rotacaoTitles) this.rotacaoTitles = [...parsed.rotacaoTitles];
        this.iniciarRotacao();
      } catch (e) { /* ignora JSON inválido */ }
    }
  },
  beforeDestroy() {
    if (this.rotacaoTimer) clearInterval(this.rotacaoTimer);
    if (this.fetchTimer) clearInterval(this.fetchTimer);
  }
};
</script>

<style scoped>
.footer {
  grid-area: footer;
  width: 100%;
  height: 52px;
  background-color: #000;
  color: #fff;
  padding: 0 10px;
  display: grid;
}

.footerStyle1 {
  grid-template-columns: minmax(0, 1fr) minmax(0, 3fr) minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr);
}

.footerStyle2 {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}

/* Itens do grid encolhiveis: impede que o conteudo (valores sem limite) estique a coluna e faca a borda "pular" */
.footer > .testBox,
.footer > .msgTxt,
.footer > .globalBox,
.footer > .reportBox {
  min-width: 0;
  overflow: hidden;
}

.footer>img {
  max-height: 62px;
  max-width: 129px;
}

.msgTxt {
  font-weight: 400;
  font-size: 0.9em;
  letter-spacing: 1px;
  text-align: center;
  justify-content: center;
  /* border-left: #fff 1px solid; */
  /* border-right: #fff 1px solid; */
}

.msgTxtOnlineRunning {
  display: grid !important;
  align-items: center;
  padding: 0 8px;
}
.msgTxtOnlineMain {
  color: #00a39f;
  font-size: 1.1em;
  letter-spacing: 1px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
}
.msgTxtOnlineSub {
  color: #fff9;
  font-size: 0.7em;
  font-weight: 600;
  line-height: 1;
  margin-top: 2px;
}

.unitNameDivisor {
  border-left: #fff 1px solid;
}


.vPosition {
  display: flex;
  align-items: center;
}

.pentagroTxt {
  justify-content: flex-end;
}

.footerPosition {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.testBox {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  border-left: #fff 1px solid;
  border-right: #fff 1px solid;
  padding: 4px 22px 4px 0;
}

.testBoxHeader {
  font-size: 0.75em;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
  opacity: 0.85;
  line-height: 1.2;
}

.testBoxRow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.testBoxCampo {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
}

.testBoxValue {
  font-size: 0.9em;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.testBoxLabel {
  font-size: 0.6em;
  opacity: 0.75;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.modal-field {
  margin-top: 12px;
  margin-bottom: 12px;
}

.modal-label {
  font-size: 0.9em;
  font-weight: 600;
  margin-bottom: 4px;
  display: block;
}

.modal-divider {
  border-top: 1px solid #dee2e6;
  margin: 16px 0 8px;
}

.modal-rotacao-input {
  max-width: 220px;
  font-weight: 600;
  margin: 0 auto 6px;
}

.modal-7col {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
  margin-bottom: 4px;
  overflow: hidden;
  min-width: 0;
}

.modal-col-header {
  font-size: 0.75em;
  font-weight: 600;
  text-align: center;
  color: #666;
}

.modal-campo-sep {
  margin: 12px 0;
  border-top: 1px solid #dee2e6;
}


.erro-salvar-msg {
  color: #dc3545;
  font-weight: bold;
  text-align: center;
  border: 1px solid #dc3545;
  border-radius: 4px;
  padding: 6px 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.modal-footer-actions {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #dee2e6;
  padding-top: 12px;
  margin-top: 16px;
}

.testBoxAddBtn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  color: #fd7e14;
  opacity: 0.6;
  cursor: pointer;
  font-size: 1em;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.testBoxAddBtn:hover {
  opacity: 1;
}

.testBoxAddBtnSpinner {
  width: 0.85em;
  height: 0.85em;
  border-width: 0.15em;
}

.globalBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  border-left: #fff 1px solid;
  border-right: #fff 1px solid;
  padding: 4px 0;
}

.globalBoxPgdi {}

.globalBoxLabels {
  display: flex;
  justify-content: space-evenly;
  font-size: 0.6em;
  opacity: 0.75;
  line-height: 1.1;
}

.reportBox {
  display: grid;
  border-left: #fff 1px solid;
  border-right: #fff 1px solid;
}

.modal-7col >>> .select-shell {
  border-color: #FF5F00 !important;
  min-height: 31px;
  height: 31px;
  padding: 4px 6px;
  font-size: 0.85rem;
  min-width: 0;
  overflow: hidden;
}

.modal-7col >>> .select-shell .arrow {
  color: #FF5F00;
}

.modal-7col >>> .select-value {
  font-size: 0.8rem;
  min-width: 0;
}

.modal-7col >>> .select-value.placeholder {
  color: #999;
  font-size: 0.8rem;
}

.globalBoxHeader {
  font-size: 0.75em;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
  opacity: 0.85;
  line-height: 1.2;
}

.globalBoxInfo {
  display: flex;
  justify-content: space-evenly;
  font-size: 0.9em;
  font-weight: 600;
  line-height: 1.2;
}

.unitInfo {
  font-size: max(11px, 0.8vw);
  letter-spacing: 0.5px;
  margin: 10px;
}

@media only screen and (max-width: 1420px) {
  .unitInfo {
    display: none;
  }

  .unitNameDivisor {
    border-left: none;
  }
}

@media only screen and (max-width: 1055px) {
  .msgTxt {
    font-size: 0.8em;
  }

  .pentagroTxt {
    font-size: 0.8em;
  }

  .globalBox, .reportBox {
    font-size: 0.8em;
  }
}

@media only screen and (max-width: 990px) {
  .footerStyle1 {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .footerStyle2 {
    grid-template-columns: 1fr 2fr 1fr;
  }
}

@media only screen and (max-width: 850px) {
  .msgTxt {
    font-size: 0.7em;
  }

  .globalBox, .reportBox {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 760px) {
  .msgTxt {
    font-size: 0.65em;
  }

  .globalBox, .reportBox {
    font-size: 0.65em;
  }
}

@media only screen and (max-width: 688px) {
  .footerStyle1 {
    grid-template-columns: 1fr 2fr 1fr;
  }

  .globalBox, .reportBox {
    display: none;
  }
}

@media only screen and (max-width: 620px) {

  .footerStyle1,
  .footerStyle2 {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media only screen and (max-width: 597px) {
  .msgTxt {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 555px) {
  .msgTxt {
    font-size: 0.65em;
  }

  .pentagroTxt {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 540px) {

  .footerStyle1,
  .footerStyle2 {
    grid-template-columns: 2fr 3fr 2fr;
  }
}

@media only screen and (max-width: 504px) {
  .msgTxt {
    font-size: 0.6em;
  }

  .pentagroTxt {
    font-size: 0.6em;
  }
}

@media only screen and (max-width: 472px) {
  .msgTxt {
    font-size: 0.6em;
  }

  .pentagroTxt {
    font-size: 0.6em;
  }
}

@media only screen and (max-width: 441px) {
  .msgTxt {
    font-size: 0.55em;
  }

  .pentagroTxt {
    font-size: 0.55em;
  }
}

@media only screen and (max-width: 390px) {
  .msgTxt {
    font-size: 0.5em;
  }

  .pentagroTxt {
    font-size: 0.5em;
  }
}
</style>

<style>
.modal-indicadores-fixos .form-control,
.modal-indicadores-fixos .custom-select {
  border-color: #fd7e14;
}
.modal-indicadores-fixos .form-control:focus,
.modal-indicadores-fixos .custom-select:focus {
  border-color: #fd7e14;
  box-shadow: 0 0 0 0.2rem rgba(253, 126, 20, 0.35);
}
.btn.btn-orange-save {
  background-color: #fd7e14;
  border-color: #fd7e14;
  color: #fff;
  transition: background-color 200ms, border-color 200ms;
}
.btn.btn-orange-save:hover,
.btn.btn-orange-save:focus {
  background-color: #e86e0a;
  border-color: #e86e0a;
  color: #fff;
}
</style>
